exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".industry-header {\n  background-color: #d6d6da !important; }\n\n.checkbox-space {\n  min-width: 25%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/market-cap-rank-top-security/market-cap-rank-top-security.component.scss
// module id = ../../../../../src/app/market-level/market-cap-rank-top-security/market-cap-rank-top-security.component.scss
// module chunks = main